<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="900px"
  >
    <v-card :loading="loading">
      <v-toolbar
        flat
        color="blue-grey"
        dark
      >
        <v-toolbar-title>Tài khoản quản lý doanh nghiệp</v-toolbar-title>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-data-table
          :loading="loading"
          v-model="accountSelected"
          :headers="headers"
          :items="items"
          item-key="name"
          show-select
        >
        </v-data-table>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {}
    },
    data () {
      return {
        loading: false,
        loading: false,
        accountSelected: [],
        dialog: false,
        errors_exist: false,
        errors: [],
        headers: [
          { text: 'Tên', value: 'name' },
          { text: 'Email', value: 'email' },
          { text: 'Tên tài khoản', value: 'username' }
        ],
        items: []
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist = false;
        if (this.showDialog) {
          this.dialog = true;
          this.getListItems();
        }
      }
    },
    methods: {
      getListItems() {
        this.loading=true;
        axios.get("api/v1/users")
          .then(response => {
            this.items = response.data;
            this.updateAccountSelected();
          })
          .catch(function (error) {
           console.log(error);
          });
      },
      updateAccountSelected() {
        axios.get(`api/v1/users-by-business/${this.item.id}`)
          .then(response => {
            let userByBusiness = response.data;
            this.accountSelected = userByBusiness;
            this.loading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(){
        const app = this;
        let id = app.item.id;
        let users = [];
        let data = {};

        app.accountSelected.forEach(function(v, i){
          users.push(v.id);
        });

        data.users = users;

        let method = "post";
        let url = `api/v1/businesses-set-account/${id}`;

        app.loading=true;

        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>